import { render } from "./InteractiveAttachmentModal.vue?vue&type=template&id=4c379c7a"
import script from "./InteractiveAttachmentModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InteractiveAttachmentModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./InteractiveAttachmentModal.vue?vue&type=style&index=0&id=4c379c7a&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__